module.exports = __webpack_public_path__ + "img/Frame1437253385.4261351e.png";